/**
 * Security Page
 *
 * Security settings including MFA, passkeys, and sessions.
 * Delegates to ConnectedSecurityModule from @bloomcode/shared-modules
 * which handles all MFA device management, passkey registration,
 * session management, and enforcement status.
 */

import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@bloomcode/ui';
import { ConnectedSecurityModule, MetaTags } from '@bloomcode/shared-modules';

export default function SecurityPage() {
  return (
    <>
      <Helmet>
        <title>Security - Bloomcode Account</title>
      </Helmet>
      <MetaTags
        title="Security Settings"
        description="Manage your account security and authentication"
      />
      <div className="container mx-auto px-4 py-8">
        <Breadcrumb className="mb-4">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>Security</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <ConnectedSecurityModule />
      </div>
    </>
  );
}
